import React from 'react'
import { LuTriangleAlert } from 'react-icons/lu'

import { SubmissionResult } from '@/components/misc/InviteOrRequestReferralPartners/types'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'

interface Props {
  invites: SubmissionResult[]
}

const UnsuccessfulInvites: React.FC<Props> = ({ invites }) => (
  <Alert variant="destructive" className="pop-in mb-4 pb-4">
    <LuTriangleAlert />

    <AlertTitle>These invites couldn't be sent</AlertTitle>

    <AlertDescription>
      <ul className="ps-0 list-none">
        {invites.map((submissionResult: SubmissionResult) => (
          <li key={submissionResult.email}>
            <span className="font-semibold">{submissionResult.email}</span>
            {` - ${submissionResult.messages?.join(' | ')}`}
          </li>
        ))}
      </ul>
    </AlertDescription>
  </Alert>
)

export default UnsuccessfulInvites
